export default "/images/image.png?a4eb884a207ee1ba5a830d06358e69de";